import { FluidOwaSource, isChapterTwoSource } from 'owa-fluid-validations';

export function getFluidScenarioName(owaSource: FluidOwaSource): string {
    return isChapterTwoSource(owaSource) ? 'MeetingNotes' : 'Component';
}
